module.exports = __webpack_public_path__ + "img/add.db631e26.png";